<div class="help-dialog">
  <div class="help-dialog-header d-flex align-items-center justify-content-between">
    <div class="help-title">How to use PPK Downloader (Basic Edition)</div>
    <button type="button" class="btn btn-link p-0 text-decoration-none" (click)="close()" aria-label="Close">
      <span class="material-icons">close</span>
    </button>
  </div>

  <div class="help-dialog-body">
    <div class="mb-3">
      <div class="section-title">What this tool does</div>
      <div class="text-muted">
        <div class="mb-2">
          PPK Downloader makes PPK (Post-Processed Kinematic) workflows simple and convenient. It can download RTCM data files directly from your NTRIP mountpoint,
          so you can generate highly accurate PPK solutions with ease.
        </div>
        <div class="mb-2">
          No need to set up and maintain a base station for PPK propose — just capture your Rover data and retrieve the base data from your existing GeoAstra mountpoints.
        </div>
        <div class="mb-2">
          Achieving centimeter-level accuracy has never been easier: simply bring a standalone RTK GNSS logger (for example: Columbus EX-1 RTK GNSS data logger) with you —
          no internet connection required.
        </div>
        <div>
          PPK Downloader supports up to 24 hours of continuous data recording, securely stored in the cloud for 7 days.
          You can start recording right away or schedule downloads to fit your project timeline.
        </div>
      </div>
    </div>

    <div class="mb-3">
      <div class="section-title">Before you start</div>
      <div class="text-muted">
        Select a mount point from the dropdown. If it shows <strong>Offline</strong>, recording may be unavailable until it becomes Online.
      </div>
    </div>

    <div class="mb-3">
      <div class="section-title">Workflow</div>
      <ol class="mb-2">
        <li>Select a mount point from <strong>Select a MountPoint</strong>.</li>
        <li>Set <strong>Recording Start Time</strong> and <strong>Recording Duration</strong>.</li>
        <li>Click <strong>Submit the Task</strong> to start/schedule the recording in backend.</li>
        <li>Click <strong>Refresh</strong> under <strong>Downloaded File</strong> to check status and get the download link when ready.</li>
      </ol>
      <div class="text-muted">
        Click the file name to download. Files are kept for a limited time (7 days).
      </div>
    </div>
  </div>
</div>


